<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    :hiddenKeys="['external_id', 'type', 'project_domain', 'tenant', 'status']"
    :show-name="false"
    :show-desc="false"
    :is-edit-name="!data.is_system"
    :is-edit-desc="!data.is_system" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import { NOTIFY_TOPIC_NAMES_MAP, NOTIFY_TOPIC_TYPES_MAP } from '@IAM/constants'
import { getEnabledTableColumn, getSwitchTableColumn } from '@/utils/common/tableColumn'
import ColumnsMixin from '../mixins/columns'
import { getSmsTemplateExtraTexts } from '../utils/smsVars'

export default {
  name: 'TopicDetail',
  mixins: [WindowsMixin, ColumnsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        {
          field: 'name',
          title: this.$t('system.notify.topic.name'),
          formatter: ({ row }) => {
            return NOTIFY_TOPIC_NAMES_MAP[row.name] || row.name || '-'
          },
        },
        {
          field: 'topic-type',
          title: this.$t('system.notify.topic.type'),
          formatter: ({ row }) => {
            return NOTIFY_TOPIC_TYPES_MAP[row.type] ? NOTIFY_TOPIC_TYPES_MAP[row.type].label : '-'
          },
        },
        getEnabledTableColumn(),
      ],
      extraInfo: [
        {
          title: this.$t('iam.topic.sms'),
          items: [
            getSwitchTableColumn({
              field: 'enable_sms',
              title: this.$t('iam.topic.enable_sms'),
              change: val => {
                const data = { enable_sms: val }
                if (!val) {
                  data.sms_template = ''
                }
                this.onManager('update', {
                  id: this.data.id,
                  managerArgs: {
                    data,
                  },
                })
              },
            }),
            {
              field: 'sms_template',
              title: this.$t('iam.topic.sms_template'),
              slots: {
                default: ({ row }) => {
                  return [
                    <span>{row.sms_template || '-'}</span>,
                    <a-icon type='edit' class='edit-icon primary-color ml-2' onclick={this.updateSmsTemplate} />,
                    <div class='text-weak mt-1'>{this.getSmsTemplateExtraTexts(row).map((text, idx) => <div key={idx}>{text}</div>)}</div>,
                  ]
                },
              },
            },
          ],
        },
        {
          title: this.$t('system.notify.topic.resources'),
          items: [
            {
              field: 'resource_types',
              title: this.$t('scope.text_653'),
              slots: {
                default: ({ row }) => {
                  if (!row.resource_types) return []
                  const ret = []
                  for (const r of row.resource_types) {
                    ret.push(<div>{this.$t(`dictionary.${r}`)}</div>)
                  }
                  return ret
                },
              },
            },
            {
              field: 'actions',
              title: this.$t('system.notify.topic.actions'),
              slots: {
                default: ({ row }) => {
                  const actions = row.actions || []
                  if (!actions.length) return '-'
                  return actions.map(a => {
                    return <div>{this.getActionLabel(a)}</div>
                  })
                },
              },
            },
          ],
        },
        {
          title: this.$t('iam.notify_time'),
          items: [
            {
              field: 'advance_days',
              title: this.$t('iam.notify_time'),
              slots: {
                default: ({ row }) => {
                  const { advance_days = [] } = row
                  if (!advance_days.length) return '-'
                  const ret = []
                  if (advance_days.length === 1) {
                    ret.push(<span>{this.$t('iam.notify_one_day', [this.$t('iam.notify_time.some_day', [advance_days[0]])])}</span>)
                  } else {
                    const dayList = []
                    advance_days.map(day => {
                      dayList.push(this.$t('iam.notify_time.some_day', [day]))
                    })
                    ret.push(<span>{this.$t('iam.notify_some_day', [dayList.join('、')])}</span>)
                  }
                  ret.push(<a-icon type='edit' class='edit-icon primary-color ml-2' onclick={this.updateNotifyTime} />)
                  return ret
                },
              },
            },
          ],
          hidden: () => !['resource release', 'password expire'].includes(this.data.name),
        },
      ],
    }
  },
  methods: {
    getSmsTemplateExtraTexts,
    getActionLabel (action) {
      const key = `iam.notify.action.${action}`
      return this.$te(key) ? this.$t(key) : action
    },
    updateNotifyTime () {
      this.createDialog('NotifyTopicUpdateTimeDialog', {
        onManager: this.onManager,
        data: [this.data],
        columns: this.columns,
      })
    },
    updateSmsTemplate () {
      this.createDialog('NotifyTopicUpdateSmsDialog', {
        onManager: this.onManager,
        data: [this.data],
        columns: this.columns,
      })
    },
  },
}
</script>

<style scoped>

</style>
